import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useField, useForm } from 'react-final-form';
import RequestMethodOption from './components/RequestMethodOption';
import {
  CREATION_TYPE_FIELD_NAME,
  CUSTOM_DOCS_FIELD_NAME,
  DOCS_FIELD_NAME,
  getDocumentsForInitialValues,
  isSpreadsheetMethod,
} from '../../utils';
import {
  DATA_ROOM_RFI_CREATION_TYPE,
  DataRoomRFICreationType,
  RfiCreateStep,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './StepRequestMethod.styles.scss';

type StepRequestMethodProps = {
  className?: string;
} & RfiCreateStep;

const StepRequestMethod: React.FC<StepRequestMethodProps> = (props) => {
  const { className } = props;

  const { change } = useForm();

  const {
    input: { value: method, onChange },
  } = useField(CREATION_TYPE_FIELD_NAME);

  const methodOptions = useMemo(
    () => [
      {
        value: DATA_ROOM_RFI_CREATION_TYPE.CHECKLIST,
        title: 'chooseFromChecklist',
        description: 'pickDocumentsOneByOneOrAddYourOwn',
      },
      {
        value: DATA_ROOM_RFI_CREATION_TYPE.SPREADSHEET,
        title: 'importFromSpreadsheet',
        description: 'uploadASheetToAddManyDocuments',
      },
    ],
    [],
  );

  const classes = classNames('step-request-method', className);

  const handleSelect = useCallback(
    (value: DataRoomRFICreationType) => {
      if (value === method) return;

      const documents = isSpreadsheetMethod(value)
        ? []
        : getDocumentsForInitialValues().documents;

      onChange(value);

      change(DOCS_FIELD_NAME, documents);
      change(CUSTOM_DOCS_FIELD_NAME, []);
    },
    [method, onChange, change],
  );

  return (
    <div className={classes}>
      {methodOptions.map(({ value, title, description }) => (
        <RequestMethodOption
          key={value}
          title={title}
          description={description}
          selected={method === value}
          onSelect={() => handleSelect(value)}
        />
      ))}
    </div>
  );
};

export default StepRequestMethod;
